export function getIconStatus(isActive, promotion) {
  if (isActive) {
    return 'active';
  }
  const { allowed, promoted } = promotion || {};
  return (allowed - promoted) ? '' : 'disabled';
}

export function addEnding(status) {
  return `${status && `-${status}`}`;
}
